import React, { useEffect, useState } from "react";
import { getSurveyJSON } from "../../../../services/jsons";
import CardSurveys from "../../../reusable/CardSurveys";
import * as echarts from "echarts";
import {
  countries,
  countries_en,
} from "../../../../utils/constants/nameCountry";
import { TOOLTIP_STYLE } from "../../../../utils/constants/graphConfigs";
import { useCurrentLanguage } from "../../../../hooks/useCurrentLanguage";

export default function Exceptions() {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();

  useEffect(() => {
    const getData = async () => {
      await fetch(
        language === "en"
          ? "/./geoJSONs/Americas/Americas_en.json"
          : "/./geoJSONs/Americas/Americas.json",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "Secure",
          },
        }
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (myJson) {
          echarts.registerMap("Americas", myJson);
        });

      const response = await getSurveyJSON("exceptions");

      //Prepare data
      if (language === "es") {
        response.data.forEach((e) => {
          e.name = countries[e.code];
        });
      } else {
        response.data.forEach((e) => {
          e.name = countries_en[e.code];
        });
      }

      setData(response);
      setIsLoading(false);
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const options = {
        backgroundColor: "transparent",
        tooltip: {
          ...TOOLTIP_STYLE,
          trigger: "item",
          showDelay: 0,
          transitionDuration: 0.2,
          formatter: function (params) {
            if (isNaN(params.value)) return "No Data";
            return (
              "<span>" +
              params.name +
              "</span><br/>" +
              params.value.toFixed(1) +
              "%"
            );
          },
        },
        visualMap: {
          top: "center",
          left: 0,
          min: data.min,
          max: data.max,
          itemHeight: 200,
          itemWidth: 30,
          textGap: 30,
          textStyle: {
            fontSize: "14px",
            fontFamily: "'Open Sans', sans-serif",
            color: "#555555",
          },
          inRange: {
            color: [
              "#341459",
              "#301A6E",
              "#252182",
              "#283B96",
              "#305EA9",
              "#4A87B6",
              "#64ACC3",
              "#7FCACF",
              "#9BDBD3",
              "#B7E6D7",
              "#D3F0E2",
            ],
          },
          text: language === "en" ? ["Agree", ""] : ["De acuerdo", ""],
          formatter: "{value}%",
          calculable: true,
        },
        series: [
          {
            id: "map",
            type: "map",
            zoom: 1.2,
            roam: true,
            scaleLimit: {
              min: 1,
              max: 8,
            },
            top: 40,
            map: "Americas",
            emphasis: {
              label: {
                show: true,
              },
            },
            data: data.data,
          },
        ],
      };

      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <CardSurveys
      isLoading={isLoading}
      options={options}
      graphTitle={data ? data.question[language] : null}
      isGraphLeft={true}
    />
  );
}
